<template>
  <div
    class="bg-white overflow-x-auto rounded-xl border border-gray-300 mx-0 search-complaints"
  >
    <a-table
      :columns="columns"
      rowKey="id"
      :data-source="dataSource"
      :pagination="false"
      :scroll="{ x: '1220px' }"
      :locale="{ emptyText: emptyTemplate }"
    >
      <div
        slot="codigo_queja"
        class="title-size font-bold text-gray-500 text-center"
      >
        Codigo queja
      </div>
      <div slot="nameCf" class="title-size font-bold text-gray-500 text-center">
        Consumidor financiero
      </div>
      <div slot="nameEv" class="title-size font-bold text-gray-500 text-center">
        Entidad vigilada
      </div>
      <div
        slot="creation_date"
        class="title-size font-bold text-gray-500 text-center"
      >
        Fecha de creación
      </div>

      <div
        slot="session_state_name"
        class="title-size font-bold text-gray-500 text-center"
      >
        Estado de la sesión
      </div>

      <div
        slot="session_date"
        class="title-size font-bold text-gray-500 text-center"
      >
        Fecha de sesión
      </div>

      <!-- Custom rendering for session_state_name column -->
      <template slot="session_state_name" slot-scope="text, record">
        <SessionsStatusLabel :status="record.session_state_name" />
      </template>

      <div slot="actions" class="title-size font-bold text-gray-500">
        Acciones
      </div>

      <div
        slot="actions"
        slot-scope="text, record"
        class="flex flex-row justify-items-center"
      >
        <!--blue eye-->
        <button
          @click="goToComplaintDetail(record)"
          class="flex justify-center text-xs mx-auto text-blue h-min"
        >
          <a-icon type="eye" :style="{ fontSize: '19px', color: '#3366cc' }" />
        </button>

        <template
          v-if="
            record.session_state_name === STATE_SESION_CHAT_AGENDADA ||
            record.session_state_name === STATE_SESION_FINALIZADA ||
            record.session_state_name === STATE_SESION_FINALIZADA_SIN_GESTION
          "
        >
          <button
            @click="viewSessionDetails(record)"
            class="flex justify-center text-xs mx-auto text-green h-min"
          >
            <a-icon
              type="file-text"
              :style="{ fontSize: '19px', color: '#3366cc' }"
            />
          </button>
        </template>

        <template
          v-if="
            record.session_state_name === STATE_SESION_PENDIENTE_AGENDAR ||
            record.session_state_name ===
              STATE_SESION_PENDIENTE_ATENDER_REPROGRAMACION
          "
        >
          <button
            @click="scheduleSession(record)"
            class="flex justify-center text-xs mx-auto text-green h-min"
          >
            <a-icon
              type="calendar"
              :style="{ fontSize: '19px', color: '#3366cc' }"
            />
          </button>
        </template>

        <template
          v-if="record.session_state_name === STATE_SESION_CHAT_AGENDADA"
        >
          <button
            @click="accessSession(record)"
            class="flex justify-center text-xs mx-auto text-green h-min"
          >
            <a-icon
              type="message"
              :style="{ fontSize: '19px', color: '#3366cc' }"
            />
          </button>
          <button
            @click="recordCloseMediationSession(record)"
            class="flex justify-center text-xs mx-auto text-green h-min"
          >
            <a-icon
              type="edit"
              :style="{ fontSize: '19px', color: '#3366cc' }"
            />
          </button>
        </template>
        <template
          v-if="record.session_state_name === STATE_SESION_FINALIZADA_SIN_GESTION"
        >
          <button
            @click="recordCloseMediationSession(record)"
            class="flex justify-center text-xs mx-auto text-green h-min"
          >
            <a-icon
              type="edit"
              :style="{ fontSize: '19px', color: '#3366cc' }"
            />
          </button>
        </template>
      </div>
    </a-table>
  </div>
</template>

<script>
const columns = [
  {
    slots: { title: "codigo_queja" },
    dataIndex: "codigo_queja",
    key: "codigo_queja",
    width: 110,
  },
  {
    slots: { title: "nameCf" },
    dataIndex: "nameCf",
    key: "nameCf",
    width: 100,
  },
  {
    slots: { title: "nameEv" },
    dataIndex: "nameEv",
    key: "nameEv",
    width: 100,
  },
  {
    slots: { title: "creation_date" },
    dataIndex: "creation_date",
    key: "creation_date",
    width: 100,
  },
  {
    slots: { title: "session_state_name" },
    dataIndex: "session_state_name",
    key: "session_state_name",
    scopedSlots: { customRender: "session_state_name" }, // Enable custom rendering
    width: 130,
  },
  {
    slots: { title: "session_date" },
    dataIndex: "session_date",
    key: "session_date",
    width: 110,
  },
  {
    slots: { title: "actions" },
    dataIndex: "actions",
    key: "actions",
    scopedSlots: { customRender: "actions" },
    width: 100,
  },
];
import {
  STATE_SESION_CHAT_AGENDADA,
  STATE_SESION_FINALIZADA,
  STATE_SESION_FINALIZADA_SIN_GESTION,
  STATE_SESION_PENDIENTE_AGENDAR,
  STATE_SESION_PENDIENTE_ATENDER_REPROGRAMACION,
} from "@/core/utils/constants";
import SessionsStatusLabel from "../partials/SessionsStatusLabel.vue";
export default {
  components: {
    SessionsStatusLabel,
  },
  props: ["dataSource"],

  data() {
    return {
      columns,
      emptyTemplate: (
        <div style="text-align: center; padding: 20px;">
          <a-icon type="inbox" style="font-size: 48px; " />
          <p
            style="margin-top: 8px; font-size: 18px;"
            class="text-gray-500 font-bold"
          >
            No se encontraron resultados
          </p>
        </div>
      ),
      STATE_SESION_CHAT_AGENDADA,
      STATE_SESION_FINALIZADA,
      STATE_SESION_FINALIZADA_SIN_GESTION,
      STATE_SESION_PENDIENTE_AGENDAR,
      STATE_SESION_PENDIENTE_ATENDER_REPROGRAMACION,
    };
  },
  methods: {
    scheduleSession(record) {
      this.$emit("scheduleSession", record);
    },
    accessSession(record) {
      this.$emit("accessSession", record);
    }, 
    goToComplaintDetail(record) {
      this.$emit("goToComplaintDetail", record);
    },
    recordCloseMediationSession(record) {
      this.$emit("recordCloseMediationSession", record);
    },
    viewSessionDetails(record) {
      this.$emit("viewSessionDetails", record);
    },
  },
};
</script>
